package com.eladfinish.bible.contest.screens.search.ui.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.tooling.preview.Preview
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.how_to_search
import com.eladfinish.bible.contest.models.ClickableTextData
import com.eladfinish.bible.contest.screens.search.usecases.clickableTextData
import com.eladfinish.bible.contest.ui.common.PreviewTheme
import com.eladfinish.bible.contest.ui.components.dialogs.GeneralHelpDialog
import com.eladfinish.bible.contest.ui.components.dialogs.HelpContentType

@Composable
fun SearchHelpDialog(
    helpDialogClickableTextData: ClickableTextData,
    isDontShowAgainChecked: Boolean,
    onExit: (Boolean) -> Unit,
    onApproveDialog: (Boolean) -> Unit,
    onDismiss: () -> Unit,
    onItemClick: (String) -> Unit = {},
) {
    GeneralHelpDialog(
        titleResource = SharedRes.strings.how_to_search,
        helpContentType = HelpContentType.Raw(helpDialogClickableTextData.text),
        spanStyles = {
            helpDialogClickableTextData.clickableAreas.map { clickableArea ->
                AnnotatedString.Range(
                    item = SpanStyle(
                        color = Color.Blue,
                        textDecoration = TextDecoration.Underline,
                    ),
                    start = clickableArea.start,
                    end = clickableArea.end
                )
            }
        },
        hasClickableParts = true,
        isDontShowAgainChecked = isDontShowAgainChecked,
        onApproveDialog = onApproveDialog,
        onDismiss = {
            onExit(false)
            onDismiss()
        },
        onItemClick = {
            onExit(false)
            onItemClick(it)
        }
    )
}

@Preview
@Composable
private fun SearchHelpDialogPreview() {
    PreviewTheme {
        SearchHelpDialog(
            helpDialogClickableTextData = clickableTextData(
                searchGuide = searchGuideMock,
                onSearchExampleClicked = {},
                debugFlag = false
            ),
            isDontShowAgainChecked = false,
            onExit = {},
            onApproveDialog = {},
            onDismiss = {},
            onItemClick = {},
        )
    }
}

private val searchGuideMock by lazy {
    """
! - גבול מילה
דוגמא: אם נרצה לחפש בדיוק את המילה "ישראל" ללא שום תוספת נוסיף סימן קריאה משני צדיה: L!ישראל!L. הוספת סימן קריאה רק בצד ימין - L!ישראלL - תחזיר מילים שמתחילות במילה ישראל. הוספת סימן קריאה רק בצד שמאל - Lישראל!L - תחזיר מילים שמסתיימות במילה ישראל. 

? - תו אופציונלי
דוגמא: הביטוי Lאברה?םL יחזיר את כל הפסוקים המכילים את המילה "אברם" או "אברהם". סימן השאלה אחרי האות ה' מציין שהאות יכולה להופיע או לא להופיע בביטוי.

^ - ראש פסוק
דוגמא: הביטוי L^טובL יחזיר את כל הפסוקים המתחילים במילה "טוב". כגון: "טוב לי תורת פיך...", "טובים השניים מן האחד...". אם רוצים דווקא את המילה "טוב" ללא תוספות אז כמובן אפשר לשלב בין הסימנים ולחפש: L^טוב!L (אפשר גם לכתוב L^!טוב!L אך ה-! הימני לא הכרחי).

: - סוף פסוק
דוגמא: הביטוי Lכסף:L יחזיר את כל הפסוקים המסתיימים במילה "כסף". כגון: "ויצאה חנם אין כסף", "... מאלפי זהב וכסף". אם רוצים דווקא את המילה "כסף" ללא תוספות אז גם כאן אפשר לשלב בין הסימנים ולחפש: L!כסף:L (אפשר גם לכתוב L!כסף!:L אך ה-! השמאלי לא הכרחי).

_ - מילה כלשהי (למעשה קו תחתון מציין 2 תווים לפחות שהם לא רווח או מקף)
דוגמא: הביטוי Lויאמר _ אל _L יחזיר את כל הפסוקים בהם מופיע שמישהו אמר למישהו משהו. כדי לדייק בחיפוש ננקד את ה-א' של אל בסגול ונקבל Lויאמר _ אֶל _L.
L^_ _ _׃L - מחזיר את כל הפסוקים המכילים 3 מילים בדיוק.

""".trimIndent()
}
